import { FC } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { IObject } from "toolkit/steps/stepSix/stepSix.types";
import { Item } from "../Item/Item";
import styles from "./List.module.sass";
import { ChangeChooseAll, ChangeChooseAllGlobal } from "toolkit/steps/stepSix/stepSix.slice";

interface ListProps {
	dataList: IObject[];
	title?: string;
	repeatable?: boolean;
	selectionButtons?: boolean;
}

export const List: FC<ListProps> = ({ dataList, title, repeatable, selectionButtons = false }) => {
	const { formationMode, batchesMode } = useAppSelector((state) => state.stepSix);
	const dispatch = useAppDispatch();

	const changeChooseAllHandler = (value: boolean) => {
		dispatch(ChangeChooseAll(value));
		dispatch(ChangeChooseAllGlobal(value));
	};

	return (
		<div className={styles["list-wrp"]}>
			{title && <span className={styles.title}>{title}</span>}
			{formationMode && selectionButtons && (
				<div className={styles.managment}>
					<button onClick={() => changeChooseAllHandler(true)} className={styles["managment-btn"]}>
						Выбрать всё
					</button>
					<button onClick={() => changeChooseAllHandler(false)} className={styles["managment-btn"]}>
						Отменить выбор
					</button>
				</div>
			)}
			<div className={styles.list}>
				{dataList.map((item) => (
					<Item key={item.id} object={item} width={batchesMode ? "big" : ""} repeatable={repeatable} />
				))}
			</div>
		</div>
	);
};
